<template>
  <label
    class="block space-y-2 rounded-2xl border p-4 duration-200"
    :class="[
      { 'border-transparent': !checked && !disabled },
      { 'border-background-positive-primary': checked },
      disabled
        ? 'bg-background-neutral-primary text-text-neutral-quaternary border-situational-lightgrey'
        : 'radio-block-box-shadow bg-background-neutral-secondary',
    ]"
    @click="onDisabled"
  >
    <FreeRadio
      class="justify-between space-x-1"
      :name="name"
      :checked="checked"
      :type="type"
      :disabled="disabled"
      :qa-id="qaId"
      @change="emit('onChange')"
    >
      <template #text>
        <slot name="title"></slot>
      </template>
    </FreeRadio>
    <slot name="description"></slot>
  </label>
</template>

<script setup lang="ts">
  import { FreeRadio } from '../FreeRadio';

  const props = withDefaults(
    defineProps<{
      name: string;
      checked?: boolean;
      type?: 'checkbox' | 'radio';
      disabled?: boolean;
      qaId?: string;
    }>(),
    {
      type: 'radio',
      qaId: '',
    },
  );

  const emit = defineEmits<{
    onChange: [];
    onDisabled: [];
  }>();

  function onDisabled() {
    if (props.disabled) {
      emit('onDisabled');
    }
  }
</script>

<style scoped>
  .radio-block-box-shadow {
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
  }
</style>
